import { createSelector } from 'reselect';
import { getState } from './state';
import { shouldShowUnreadMarkers } from '../helpers/roomState';

export const getUnreadRoomSlice = createSelector([getState], slice => {
  return slice.roomUnreadState ?? {};
});

export const getRoomUnreadState = createSelector(
  getUnreadRoomSlice,
  (state, room_id) => room_id,
  (state, room_id) => state[room_id]
);

export const getUnreadCount = createSelector(
  getRoomUnreadState,
  roomUnreadState => {
    if (!roomUnreadState || !shouldShowUnreadMarkers(roomUnreadState)) {
      return undefined;
    }

    return roomUnreadState.unreadMessageCount;
  }
);

export const getRoomWindowState = createSelector(
  getRoomUnreadState,
  roomUnreadState => roomUnreadState?.windowState
);
